import { render, staticRenderFns } from "./invinlist.vue?vue&type=template&id=60eef5e6&scoped=true&"
import script from "./invinlist.vue?vue&type=script&lang=js&"
export * from "./invinlist.vue?vue&type=script&lang=js&"
import style0 from "./invinlist.vue?vue&type=style&index=0&id=60eef5e6&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60eef5e6",
  null
  
)

export default component.exports